export default class {
    _id;
    _uid;
    _createdOn;
    _postCode;
    _region;
    _account;
    _postIndex;

    get id() {
        return this._id;
    }

    set id(value) {
        this._id = value;
    }

    get uid() {
        return this._uid;
    }

    set uid(value) {
        this._uid = value;
    }

    get createdOn() {
        return this._createdOn;
    }

    set createdOn(value) {
        this._createdOn = value;
    }

    get postCode() {
        return this._postCode;
    }

    set postCode(value) {
        this._postCode = value;
    }

    get region() {
        return this._region;
    }

    set region(value) {
        this._region = value;
    }

    get account() {
        return this._account;
    }

    set account(value) {
        this._account = value;
    }

    get postIndex() {
        return this._postIndex;
    }

    set postIndex(value) {
        this._postIndex = value;
    }
}